import React, { useImperativeHandle, useRef, useEffect, forwardRef, useState } from "react";
import { Modal } from 'bootstrap';
import TapSelect from "../../../components/ui/TapSelect";
import Loader from "../../../components/ui/Loader/Loader";
import { BACKOFFICE_BASE_URL } from "../../../services/TapApiUrls";
import HttpAPICall from "../../../services/HttpAPICall";
import { useSelector } from "react-redux";


const AssetMatrixSearchModal = forwardRef(({ submitSearchFormProp }, ref) => {

    const amFormDataUrl         =   BACKOFFICE_BASE_URL + '/asset_matrix/form_data';
    const access_token          =   useSelector(state => state.auth.access_token);
    const modalElem             =   useRef(null);
    const searchModal           =   useRef(null);

    const initialSearching      =   {
        like_asset_matrix           :   '',
        search_asset_type_ids       :   [],
        search_manufacturers        :   [],
        search_models               :   [],
    }

    const [aMSearchForm, setAMSearchForm] = useState(initialSearching);

    const searchFormLabel       =   {
        like_asset_matrix           :   'Asset Matrix : ',
        search_asset_type_ids       :   'Asset Types : ',
        search_manufacturers        :   'Manufacturers : ',
        search_models               :   'Models : '
    };

    const [formLoading, setFormLoading] =   useState(false);   
    const [formData, setFormData]       =   useState({
        assetType           :   [],
        manufacturers       :   [],
        models              :   [],
    });

    useImperativeHandle(ref, () => ({
        initModalHandler: () => {
            searchModal.current.show();
            getFormData();
        },
        clearSearchForm: () => {
            setAMSearchForm(initialSearching)
        }
    }));

    useEffect(() => {
        modalElem.current = document.getElementById("assetMatrixSearchID");
        searchModal.current = new Modal(modalElem.current, { keyboard: false, backdrop: false });
        return () => {
            if (searchModal.current) {
                searchModal.current.dispose();
            }
        };
    }, []);

    const getFormData = () => {
        setFormLoading(true);
        HttpAPICall.withAthorization('GET', amFormDataUrl, access_token, {list_form_data : 'Y'}, {}, (resp) => {
            const respData = resp.data;
            setFormData({
                assetType       :   respData.asset_type.map(at => ({label : at.asset_type_name, value: at.id})),
                manufacturers   :   respData.manufacturers.map(s => ({label : s.manufacturer, value: s.id})),
                models          :   respData.models.map(s => ({label : s.model, value: s.id})),
            });
        }).then(() =>  setFormLoading(false));
    };

    const submitSearchForm = (e) => {
        e && e.preventDefault()
        let serachFormKeys = Object.keys(aMSearchForm);
        let searchedElems = [];
        let searchParams = {};
        serachFormKeys.map((key) => {
            let label = searchFormLabel[key];
            let value = aMSearchForm[key];
            if (value && value.toString().length > 0) {
                searchParams[key] = value;
                if (label) {
                    let show_val = value;

                    if (key == 'like_asset_matrix') {
                        show_val = aMSearchForm ? aMSearchForm.like_asset_matrix : '';
                    }
                    if (key == 'search_asset_type_ids') {
                        show_val = formData.assetType.filter(s => aMSearchForm.search_asset_type_ids.includes(s.value)).map(s => s.label).join(', ');
                    }
                    if (key == 'search_manufacturers') {
                        show_val = formData.manufacturers.filter(s => aMSearchForm.search_manufacturers.includes(s.value)).map(s => s.label).join(', ');
                    }
                    if (key == 'search_models') {
                        show_val = formData.models.filter(s => aMSearchForm.search_models.includes(s.value)).map(s => s.label).join(', ');
                    }
                    console.log(show_val);
                    
                    searchedElems.push(label + `<b>${show_val}</b>`);
                }
            }
        });
        submitSearchFormProp(searchedElems, aMSearchForm);
        searchModal.current.hide();
    };

    const searchModalClose = () => {
        searchModal.current && searchModal.current.hide();
    };

    
    return (
        <>
            <div className="modal fade" id={"assetMatrixSearchID"} tabIndex="-1" ref={modalElem}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="employeeSearchModalLabel">Asset Matrix Search</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={searchModalClose} aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <form id="assetMatrixSearchForm" onSubmit={submitSearchForm}>
                                <div className="modal-body">
                                    {formLoading ? <Loader />
                                        : <>
                                        <div className="row my-3 align-items-center">
                                                <label className="col-sm-2 col-form-label col-form-label-sm">Asset Matrix ID</label>
                                                <div className="col-sm-10">
                                                    <input
                                                        name="like_asset_matrix"
                                                        type="text"
                                                        value={aMSearchForm.like_asset_matrix}
                                                        className="form-control"
                                                        autoComplete="off"
                                                        onChange={(e) => {
                                                            setAMSearchForm(pre => ({...pre, [e.target.name] : e.target.value}))
                                                        }}
                                                        placeholder="Please Enter Asset Matrix ID"
                                                        style={{ height: "30px", fontSize: "93%" }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row my-3 align-items-center">
                                                <label className="col-sm-2 col-form-label col-form-label-sm">Asset Type</label>
                                                <div className="col-sm-10">
                                                    <TapSelect
                                                        options={formData.assetType}
                                                        changeEvent={(selectedOption) => {
                                                            if(selectedOption) {
                                                                setAMSearchForm(pre => ({
                                                                    ...pre, search_asset_type_ids:  selectedOption.map(s => s.value) 
                                                                }))
                                                            }
                                                        }}
                                                        value={formData.assetType.filter(at => aMSearchForm.search_asset_type_ids.includes(at.value))}
                                                        isMulti={true}
                                                        isSearchable={true}
                                                        isClearable={true}
                                                        placeholder="Select Asset Type"
                                                        containerHeight="30px"
                                                        fontSize="93%"
                                                    />
                                                </div>
                                            </div>
                                            <div className="row my-3 align-items-center">
                                                <label className="col-sm-2 col-form-label col-form-label-sm">Manufacturer</label>
                                                <div className="col-sm-10">
                                                    <TapSelect
                                                        options={formData.manufacturers}
                                                        changeEvent={(selectedOption) => {
                                                            if(selectedOption) {
                                                                setAMSearchForm(pre => ({
                                                                    ...pre, search_manufacturers:  selectedOption.map(s => s.value) 
                                                                }))
                                                            }
                                                        }}
                                                        value={formData.manufacturers.filter(at => aMSearchForm.search_manufacturers.includes(at.value))}
                                                        isMulti={true}
                                                        isSearchable={true}
                                                        isClearable={true}
                                                        placeholder="Select manufacturers"
                                                        containerHeight="30px"
                                                        fontSize="93%"
                                                    />
                                                </div>
                                            </div>
                                            <div className="row my-3 align-items-center">
                                                <label className="col-sm-2 col-form-label col-form-label-sm">Model</label>
                                                <div className="col-sm-10">
                                                    <TapSelect
                                                        options={formData.models}
                                                        changeEvent={(selectedOption) => {
                                                            if(selectedOption) {
                                                                setAMSearchForm(pre => ({
                                                                    ...pre, search_models:  selectedOption.map(s => s.value) 
                                                                }))
                                                            }
                                                        }}
                                                        value={formData.models.filter(at => aMSearchForm.search_models.includes(at.value))}
                                                        isMulti={true}
                                                        isSearchable={true}
                                                        isClearable={true}
                                                        placeholder="Select models"
                                                        containerHeight="30px"
                                                        fontSize="93%"
                                                    />
                                                </div>
                                            </div>
                                        </>}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={searchModalClose} data-bs-dismiss="modal">Close</button>
                                    <button type="submit" disabled={formLoading} className="btn btn-primary">Search</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
});

export default AssetMatrixSearchModal;
